module.exports = __webpack_public_path__ + "img/20190516105100btn_11_03.e5c1c70d.png";